import { LocationIcon } from "../../icons/locationIcon"
import { PhoneIcon } from "../../icons/phoneIcon"
import { Button } from "../ui/Button"


export const ServiceSummary = ({ setFormStep, onSubmitService, summaryData }) => {


    return (
        <div className="flex flex-col gap-4 relative">
        <div className="max-lg:w-full max-lg:my-5 order-last lg:absolute flex max-lg:flex-col-reverse gap-4 lg:gap-10 lg:-top-[60px] lg:right-0">
            <Button className={'border border-[#A5A5A5] py-3 px-10 rounded-[6px] text-primary-button'} onClick={()=> {setFormStep(0)}}>Ακύρωση</Button>
            <Button  className={'disabled:bg-[#A5A5A5] rounded-[6px] bg-[#D4002A] py-3 px-10 text-primary-button text-white'} onClick={onSubmitService}>Επόμενο</Button>
        </div>
            <h4>Σύνοψη στοιχείων ραντεβού</h4>
            <div className="flex flex-col gap-6 p-6 bg-white rounded-[12px] min-w-[600px]">
                <div className="flex flex-col gap-2">
                    <h6>{summaryData.marker.name}</h6>
                    <div className="flex gap-1">
                        <LocationIcon />
                        <p className="text-disclaimer w-[90%]">{summaryData.marker.address}</p>
                    </div>
                    <div className="flex gap-1 items-center">
                        <PhoneIcon />
                        <p className="text-disclaimer">{summaryData.marker.phone}</p>
                    </div>
                </div>
                <div className="flex flex-col gap-2">
                    <h6>Ημερομηνία & ώρα</h6>
                    <p className="text-disclaimer w-[90%]">{summaryData.timeSlot.split('T')[0].split('-')[2] + '/' +summaryData.timeSlot.split('T')[0].split('-')[1] + '/' + summaryData.timeSlot.split('T')[0].split('-')[0]}</p>
                    <p className="text-disclaimer">{new Date(summaryData.timeSlot).toLocaleTimeString('el-GR',{
                        timeZone: 'Europe/Athens',
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: false, // Use 24-hour format
                        hourCycle: 'h23' // Force 2-digit hours
                    })}</p>
                </div>
                <div className="flex flex-col gap-2">
                    <h6>Pick-up & Delivery</h6>
                    <p className="text-disclaimer w-[90%]">{summaryData.wantPickupDelivery ? 'Ναι' : 'Όχι'}</p>
                </div>
            </div>
            {summaryData.bodyWork &&
                <div className="flex flex-col gap-6 p-6 bg-white rounded-[12px]">
                <h4>Φανοποιία</h4>
                <p className="text-disclaimer w-[90%]">{summaryData.bodyWork}</p>
            </div>
            }
            {summaryData.tyreChange &&
                <div className="flex flex-col gap-6 p-6 bg-white rounded-[12px]">
                    <h4>Αλλαγή ελαστικών</h4>
                    <div className="flex flex-col">
                        <h6>Εμπρόσθια ελαστικά </h6>
                        <p className="text-disclaimer w-[90%]">{summaryData.tyreChange.frontTyreWidth}/{summaryData.tyreChange.frontTyreHeight}/{summaryData.tyreChange.frontTyreDiameter}</p>
                    </div>
                    <div className="flex flex-col">
                        <h6>Οπίσθια ελαστικά </h6>
                        {summaryData.tyreChange.rearSameAsFront ?
                            <p className="text-disclaimer w-[90%]">{summaryData.tyreChange.frontTyreWidth}/{summaryData.tyreChange.frontTyreHeight}/{summaryData.tyreChange.frontTyreDiameter}</p> :
                            <p className="text-disclaimer w-[90%]">{summaryData.tyreChange.rearTyreWidth}/{summaryData.tyreChange.rearTyreHeight}/{summaryData.tyreChange.rearTyreDiameter}</p>
                        }
                    </div>
                    <div className="flex flex-col">
                        <h6>RunFlat ελαστικά</h6>
                        <p className="text-disclaimer w-[90%]">{summaryData.tyreChange.tyreRunFlat ? 'Yes' : 'No'}</p>
                    </div>
            </div>
            }
            <div className="flex flex-col gap-3 p-6 bg-white rounded-[12px]">
                <h4>Επιπλέον σχόλια</h4>
                <p className="text-disclaimer w-[90%]">{summaryData.additionalComments}</p>
            </div>   
                
    </div>
    )
}